// error.service.ts

import { NavigationPayload } from "./NavigationContext";

let navigationHandler: ((error: NavigationPayload) => void) | null = null;

export const registerNavigationHandler = (
  handler: (e: NavigationPayload) => void,
) => {
  navigationHandler = handler;
};

export const navigateTo = (error: NavigationPayload) => {
  if (!navigationHandler) {
    console.warn("Navigation handler not registered yet", error);
    return;
  }
  navigationHandler(error);
};
